<template>
    <div>
        <InstructionText v-if="settings.showInstruction">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="$t('Page(ReceivedRequest):Component(Instruction):approve-declaration')" />
        </InstructionText>

        <LegacyDeclarationApproval
            class="no-border"
            label=""
            :request-id="context.requestId"
            @confirmed="handleConfirmed"
        />
    </div>
</template>

<script>
import InstructionText from '@core/components/common/instructions/InstructionText.vue'
import LegacyDeclarationApproval from '@/views/request/received/components/DeclarationApproval.vue'

export default {
    name: 'DeclarationApprovalStep',
    components: {
        InstructionText,
        LegacyDeclarationApproval,
    },
    props: {
        context: { type: Object, required: true },
        settings: { type: Object, required: true },
        runtimeState: { type: Object, required: true },
    },
    methods: {
        async handleConfirmed() {
            try {
                await this.context.services.markDeclarationApproved()
                this.$emit('completed', { isValid: true, errors: [] })
            } catch (error) {
                this.$emit('error', error)
            }
        },
    },
}
</script>
